import React, { useEffect, useState } from "react";
import globeIcon from "../../../../assets/images/globeIcon.svg";
import infoIcon from "../../../../assets/images/infoIcon.svg";
import wordpress from "../../../../assets/images/wordpress.svg";
import hubspot from "../../../../assets/images/hubspot.svg";
import drupal from "../../../../assets/images/drupalIcon.svg";
import geocoder from "../../../../assets/images/geocoderIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getDomainById, putDomains } from "../../../../utils/api";
import { useAuth } from "../../../../hooks/useAuth";
import Modal from "../../../../components/Modal";
import Tooltip from "../../../../components/Tooltip/Tooltip";

const EditDomainForm = () => {
  const { accessToken } = useAuth();
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    if (!accessToken) return;

    getDomainById(accessToken, id).then((res) => {
      setData(res.data.data);
    });
  }, [id, accessToken]);

  const [formData, setFormData] = useState({
    domainName: "",
    websiteType: {
      name: "WordPress",
      icon: wordpress,
    },
    status: "1",
  });

  useEffect(() => {
    if (data.length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        domainName: data[0]?.name || "",
        websiteType: {
          name:
            data[0]?.project_type === "Images"
              ? "Geocoder"
              : data[0]?.project_type,
          icon:
            data[0]?.project_type === "WordPress"
              ? wordpress
              : data[0]?.project_type === "Hubspot"
                ? hubspot
                : data[0]?.project_type === "Drupal"
                  ? drupal
                  : geocoder,
        },
        status: data[0]?.status,
      }));
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSelect = (name, icon) => {
    setFormData((prevData) => ({
      ...prevData,
      websiteType: { name, icon },
    }));
    document.getElementById("type-dropdown").classList.add("hidden");
  };

  const handleSubmit = async () => {
    const newDomain = {
      name: formData.domainName,
      project_type:
        formData.websiteType.name === "Geocoder"
          ? "Images"
          : formData.websiteType.name,
      status: formData.status,
    };

    try {
      await putDomains(accessToken, newDomain, id);

      setModalMessage("Domain saved successfully!");
      setIsError(false);
      setIsModalOpen(true);

      setTimeout(() => {
        navigate("/domains");
      }, 2000);
    } catch (error) {
      setModalMessage(
        error.response?.data?.message || "Failed to save domain:",
      );
      setIsError(true);
      setIsModalOpen(true);
    }
  };

  return (
    <div className="px-[35px]">
      <div className="max-w-[1095px] p-[25px] bg-white rounded-lg border-[1px] border-[#E0E0E0]">
        <div className="flex items-center mb-6">
          <div className="bg-gradient p-[13px] w-[45px] rounded-[6px] mr-[16px]">
            <img src={globeIcon} alt="Domain Icon" />
          </div>
          <div>
            <h2 className="text-[18px] font-semibold">Edit Domain</h2>
            <p className="text-[#8C8C8C] text-[12px]">
              Make sure there are no typos, once added you cannot make changes.
            </p>
          </div>
        </div>
        <form className="flex flex-col">
          <div className="w-full flex flex-col sm:flex-row gap-[10px] sm:gap-0 justify-between">
            <div className="flex flex-col max-w-full sm:max-w-[776px] w-full mr-[10px]">
              <label
                htmlFor="domainName"
                className="flex text-[#001522] font-[600] text-[12px]"
              >
                Domain Name
                <Tooltip tooltip="Domain Name">
                  <img src={infoIcon} alt="Info Icon" className="ml-[4px]" />
                </Tooltip>
              </label>
              <input
                type="text"
                id="domainName"
                placeholder="serps.com"
                value={formData.domainName}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus-visible:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm font-bold"
              />
            </div>
            <div className="flex flex-col max-w-full sm:max-w-[139px] w-full mr-[10px] relative">
              <label
                htmlFor="website-type"
                className="flex text-[#001522] font-[600] text-[12px]"
              >
                Website Type
                <Tooltip tooltip="Website Type">
                  <img src={infoIcon} alt="Info Icon" className="ml-[4px]" />
                </Tooltip>
              </label>
              <div className="relative mt-1">
                <div
                  className="flex items-center px-[15px] py-[8px] border border-gray-300 rounded-md shadow-sm cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("type-dropdown")
                      .classList.toggle("hidden")
                  }
                >
                  <img
                    src={formData.websiteType.icon}
                    alt={formData.websiteType.name}
                    className="w-[18px] mr-[7px]"
                  />
                  <span className="text-[#616161] text-[13px] font-[500]">
                    {formData.websiteType.name}
                  </span>
                  <svg
                    className="ml-auto w-[13px] text-black font-bold"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <ul
                  id="type-dropdown"
                  className="absolute w-full bg-white shadow-lg rounded-md z-10 hidden"
                >
                  <li
                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleSelect("WordPress", wordpress)}
                  >
                    <img
                      src={wordpress}
                      alt="WordPress"
                      className="w-[18px] mr-[7px]"
                    />
                    WordPress
                  </li>
                  <li
                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleSelect("Hubspot", hubspot)}
                  >
                    <img
                      src={hubspot}
                      alt="Hubspot"
                      className="w-[18px] mr-[7px]"
                    />
                    Hubspot
                  </li>
                  <li
                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleSelect("Drupal", drupal)}
                  >
                    <img
                      src={drupal}
                      alt="Drupal"
                      className="w-[18px] mr-[7px]"
                    />
                    Drupal
                  </li>
                  <li
                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleSelect("Images", geocoder)}
                  >
                    <img
                      src={geocoder}
                      alt="Geocoder"
                      className="w-[18px] mr-[7px]"
                    />
                    Geocoder
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col max-w-full sm:max-w-[86px] w-full">
              <label
                htmlFor="status"
                className="flex text-[#001522] font-[600] text-[12px]"
              >
                Status
                <Tooltip tooltip="Status">
                  <img src={infoIcon} alt="Info Icon" className="ml-[4px]" />
                </Tooltip>
              </label>
              <select
                id="status"
                value={formData.status}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[13px] text-[#001522] focus:ring-orange-500 focus-visible:outline-none focus:border-orange-500 sm:text-sm"
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            className="flex items-center justify-center px-4 py-2 bg-gradient text-[12px] text-white font-semibold rounded-md focus:outline-none w-fit mt-[25px]"
          >
            Save Domain
          </button>
        </form>
      </div>
      {isModalOpen && (
        <Modal
          message={modalMessage}
          isError={isError}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default EditDomainForm;
